import { gql } from "@apollo/client";

const GET_USER = gql`
  query user($id: ID!) {
    user(id: $id) {
      id
      email
      firstName
      lastName
      type
      location {
        id
        name
        operations {
          workingHours {
            monday {
              open
              close
            }
            tuesday {
              open
              close
            }
            wednesday {
              open
              close
            }
            thursday {
              open
              close
            }
            friday {
              open
              close
            }
            saturday {
              open
              close
            }
            sunday {
              open
              close
            }
          }
          holidays {
            date
            repeat
            isOpen
            hours {
              open
              close
            }
          }
        }        
      }
    }
  }
`;

export { GET_USER };
